const Footer = () => {
	return (
		<footer className="footer">
			<div className="container">
				<div className="footer-content">
					<div className="footer-about">
						<h3>Trivnet Services</h3>
						<p>
							Providing innovative IT solutions since 2010. We help businesses
							leverage technology to achieve their goals and stay ahead of the
							competition.
						</p>
						<div className="social-links">
							<a href="#">
								<i className="fab fa-facebook-f"></i>
							</a>
							<a href="#">
								<i className="fab fa-twitter"></i>
							</a>
							<a href="#">
								<i className="fab fa-linkedin-in"></i>
							</a>
							<a href="#">
								<i className="fab fa-instagram"></i>
							</a>
						</div>
					</div>

					<div className="footer-links">
						<h3>Quick Links</h3>
						<ul>
							<li>
								<a href="/">Home</a>
							</li>
							<li>
								<a href="/services">Services</a>
							</li>
							<li>
								<a href="/about">About Us</a>
							</li>
							<li>
								<a href="/portfolio">Portfolio</a>
							</li>
							<li>
								<a href="/contact">Contact</a>
							</li>
							<li>
								<a href="/blog">Blog</a>
							</li>
						</ul>
					</div>

					<div className="footer-services">
						<h3>Our Services</h3>
						<ul>
							<li>
								<a href="/services/software-development">
									Software Development
								</a>
							</li>
							<li>
								<a href="/services/cloud-services">Cloud Services</a>
							</li>
							<li>
								<a href="/services/cybersecurity">Cybersecurity</a>
							</li>
							<li>
								<a href="/services/mobile-apps">Mobile Apps</a>
							</li>
							<li>
								<a href="/services/data-analytics">Data Analytics</a>
							</li>
							<li>
								<a href="/services/ai-ml">AI & ML</a>
							</li>
						</ul>
					</div>

					<div className="footer-newsletter">
						<h3>Newsletter</h3>
						<p>
							Subscribe to our newsletter to receive updates on our latest
							services and offers.
						</p>
						<form>
							<input type="email" placeholder="Your Email" required />
							<button type="submit">Subscribe</button>
						</form>
					</div>
				</div>

				<div className="footer-bottom">
					<p>
						&copy; {new Date().getFullYear()} Trivnet Services Limited. All
						Rights Reserved.
					</p>
					<div className="legal-links">
						<a href="/privacy">Privacy Policy</a>
						<a href="/terms">Terms of Service</a>
						<a href="/cookies">Cookie Policy</a>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
